"use client";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import "../wasm/wasm_exec.js";
import * as walletUtils from "./walletUtils.js";
import {
  getPortalBaseURL,
  initClient,
  mpcComputationClient,
  paraVersion,
  WalletType
} from "@getpara/core-sdk";
function loadWasm(ctx, wasmOverride) {
  return __async(this, null, function* () {
    if (typeof self === "undefined") {
      return;
    }
    const goWasm = new self.Go();
    let wasmArrayBuffer = wasmOverride;
    if (!wasmArrayBuffer) {
      if (process.env.DISABLE_WASM_FETCH === "true") {
        throw new Error("fetching wasm file is disabled");
      }
      const fetchedWasm = yield fetch(`${getPortalBaseURL(ctx)}/static/js/main.wasm`, { mode: "cors" });
      wasmArrayBuffer = yield fetchedWasm.arrayBuffer();
    }
    const newRes = yield WebAssembly.instantiate(wasmArrayBuffer, goWasm.importObject);
    goWasm.run(newRes.instance);
  });
}
function executeMessage(ctx, message) {
  return __async(this, null, function* () {
    const { functionType, params, returnObject } = message;
    switch (functionType) {
      case "KEYGEN": {
        const { userId, secretKey, type = WalletType.EVM } = params;
        const keygenRes = yield walletUtils.keygen(ctx, userId, type, secretKey);
        return keygenRes;
      }
      case "SIGN_TRANSACTION": {
        const { share, walletId, userId, tx, chainId } = params;
        return walletUtils.signTransaction(ctx, share, walletId, userId, tx, chainId);
      }
      case "SEND_TRANSACTION": {
        const { share, walletId, userId, tx, chainId } = params;
        return walletUtils.sendTransaction(ctx, share, walletId, userId, tx, chainId);
      }
      case "SIGN_MESSAGE": {
        const { share, walletId, userId, message: message2, cosmosSignDoc } = params;
        return walletUtils.signMessage(ctx, share, walletId, userId, message2, cosmosSignDoc);
      }
      case "REFRESH": {
        const { share, walletId, userId, oldPartnerId, newPartnerId, keyShareProtocolId } = params;
        const { protocolId, signer } = yield walletUtils.refresh(
          ctx,
          share,
          walletId,
          userId,
          oldPartnerId,
          newPartnerId,
          keyShareProtocolId
        );
        return returnObject ? { protocolId, signer } : signer;
      }
      case "PREKEYGEN": {
        const { email, partnerId, secretKey, type = WalletType.EVM } = params;
        let { pregenIdentifier, pregenIdentifierType } = params;
        if (email !== "null" && email !== "undefined" && email !== "" && email != null) {
          pregenIdentifier = email;
          pregenIdentifierType = "EMAIL";
        }
        const keygenRes = yield walletUtils.preKeygen(ctx, partnerId, pregenIdentifier, pregenIdentifierType, type, secretKey);
        return keygenRes;
      }
      case "GET_PRIVATE_KEY": {
        const { share, walletId, userId } = params;
        return yield walletUtils.getPrivateKey(ctx, share, walletId, userId);
      }
      case "ED25519_KEYGEN": {
        const { userId } = params;
        return walletUtils.ed25519Keygen(ctx, userId);
      }
      case "ED25519_SIGN": {
        const { share, walletId, userId, base64Bytes } = params;
        return walletUtils.ed25519Sign(ctx, share, userId, walletId, base64Bytes);
      }
      case "ED25519_PREKEYGEN": {
        const { email } = params;
        let { pregenIdentifier, pregenIdentifierType } = params;
        if (email !== "null" && email !== "undefined" && email !== "" && email != null) {
          pregenIdentifier = email;
          pregenIdentifierType = "EMAIL";
        }
        return walletUtils.ed25519PreKeygen(ctx, pregenIdentifier, pregenIdentifierType);
      }
      default: {
        throw new Error(`functionType: ${functionType} not supported`);
      }
    }
  });
}
function handleMessage(e, postMessage, useFetchAdapter) {
  return __async(this, null, function* () {
    const {
      env,
      apiKey,
      cosmosPrefix = "cosmos",
      offloadMPCComputationURL,
      disableWorkers,
      sessionCookie,
      useDKLS,
      disableWebSockets,
      wasmOverride
    } = e.data;
    if (!env) {
      return true;
    }
    const ctx = {
      env,
      apiKey,
      cosmosPrefix,
      client: initClient({
        env,
        version: paraVersion,
        apiKey,
        useFetchAdapter,
        retrieveSessionCookie: () => sessionCookie
      }),
      offloadMPCComputationURL,
      mpcComputationClient: offloadMPCComputationURL ? mpcComputationClient.initClient(offloadMPCComputationURL, !!disableWorkers) : void 0,
      useDKLS,
      disableWebSockets: !!disableWebSockets,
      wasmOverride
    };
    if (!ctx.offloadMPCComputationURL || ctx.useDKLS) {
      yield loadWasm(ctx, wasmOverride);
    }
    const result = yield executeMessage(ctx, e.data);
    postMessage(result);
    return false;
  });
}
export {
  handleMessage
};
